import { getConfig } from '../../config';
import { LitElement, html } from 'lit';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { SearchResultBannersWCReact } from './search-result-banners';
import { SearchSummary } from '../../../shared/types/adsense';
import { customElement, property } from 'lit/decorators.js';
import { displayAdsLog } from '../../utils/debug';
import { subscribe, unsubscribe } from '../../podlet/events';
import { Event } from '@podium/browser';

export const NAME = 'search-result-banners-web-component';
const config = getConfig();

@customElement(NAME)
export class SearchResultBannersWebComponent extends LitElement {
    @property({ type: Object })
    searchSummary: SearchSummary;

    @property({ type: Number })
    cols: 1 | 2 | 3;

    @property({ type: String })
    className: '';

    @property({ type: Number })
    cycle: number | undefined;

    constructor() {
        super();
        this.updateSlots = this.updateSlots.bind(this);
        this.slotChangeHandler = this.slotChangeHandler.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();

        this.setAttribute('class', this.className);

        this.refreshCallback = this.refreshCallback.bind(this);
        subscribe('banner', 'refresh', this.refreshCallback);
    }

    firstUpdated() {
        const slot = this.shadowRoot.querySelector('#slot-container');
        slot.addEventListener('slotchange', this.slotChangeHandler);
    }

    slotChangeHandler() {
        console.log('Slot contents changed');
        this.updateSlots(this.cycle);
    }

    refreshCallback(event: Event) {
        const cycle = event.payload;
        if (cycle) {
            this.updateSlots(cycle as number);
        }
    }

    updateSlots(cycle: number = 0) {
        this.cycle = cycle;

        // clear all existing slots
        const slots = this.querySelectorAll('.banner-placement-slot');
        if (slots) {
            slots.forEach((slot) => {
                while (slot.firstChild) {
                    slot.removeChild(slot.firstChild);
                }
            });
        }

        // set the new slots
        this.setSlots(cycle);
    }
    disconnectedCallback() {
        displayAdsLog(NAME, 'disconnectedCallback()');
        // clean up event listeners or subscriptions
        super.disconnectedCallback();
        unsubscribe('banner', 'refresh', this.refreshCallback);

        const slot = this.shadowRoot.querySelector('#slot-container');
        slot.removeEventListener(
            'slotchange',
            this.slotChangeHandler.bind(this),
        );
    }

    setSlots(cycle: number = 0) {
        displayAdsLog('setSlots()');
        const selectedType = 'list';

        displayAdsLog('updateComplete');

        const { slotNodes, slotNodesLength } = this.getSlotNodes();

        const placementInstruction = config?.placementInstructions?.find(
            ({ type }) => {
                displayAdsLog({ type, selectedType });
                return true;
            },
        );
        displayAdsLog({ placementInstruction, slotNodes });

        let pos = 0;
        placementInstruction?.intervals?.forEach(
            ({ placementId, interval }, index) => {
                pos += interval;
                const placementIdWithCycle = `${placementId}${
                    cycle !== 0 ? cycle : ''
                }`;

                displayAdsLog({
                    placementIdWithCycle,
                    placementId,
                    interval,
                    pos,
                    slotNodesLength,
                });

                if (slotNodesLength > pos) {
                    const slotNodesPlacement = slotNodes[interval + 1];
                    displayAdsLog({ slotNodesPlacement });
                    if (slotNodesPlacement) {
                        let adContainer =
                            this.getAdContainer(placementIdWithCycle);

                        displayAdsLog({ adContainer });
                        this.renderAdContainer(
                            placementId,
                            index,
                            adContainer,
                            pos,
                        );
                    }
                }
            },
        );
    }
    renderAdContainer(placementId, index, adContainer, pos) {
        ReactDOM.render(
            <SearchResultBannersWCReact
                id={placementId}
                searchSummary={this.searchSummary}
                cols={this.cols}
                vertical={config.vertical}
                subvertical={config.subvertical}
                index={index + 1}
            />,
            adContainer,
        );

        this.insertBefore(adContainer, this.children[pos]);
    }

    getSlotNodes() {
        const slot: HTMLSlotElement =
            this.shadowRoot.querySelector('#slot-container');
        const slotNodes = slot.assignedNodes();
        const slotNodesLength = slotNodes.length;

        return { slotNodes, slotNodesLength };
    }

    getAdContainer(placementId) {
        displayAdsLog(NAME, 'getAdContainer()', placementId);

        let adContainer = document.getElementById(placementId + '-slot');
        if (adContainer) {
            while (adContainer.firstChild) {
                adContainer.removeChild(adContainer.firstChild);
            }
        } else {
            adContainer = document.createElement('div');
            adContainer.setAttribute('slot', placementId + '_slot');
            adContainer.setAttribute('id', placementId);
            adContainer.setAttribute('class', 'banner-placement-slot');
        }
        return adContainer;
    }

    render() {
        displayAdsLog(`render()`);
        return html`
            <div>
                <slot id="slot-container"
                    >Replace this with classified ads and insert advertisement
                </slot>
            </div>
        `;
    }
}
